import { ImageCardWrapper } from '@/components/AboutUsPageTemplate.styles'
import { Container, Image, Wrapper } from '@/components/widgets/blog/ImageFan.styles'

type ImageFanProps = {
  first: string
  second: string
  third: string
}

const ImageFan: React.FC<ImageFanProps> = ({ first, second, third }) => {
  return (
    <Container>
      <Wrapper>
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <Image rotation={3} image={first} />

        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <Image rotation={-6} image={second} />

        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <Image rotation={4} image={third} />
      </Wrapper>
    </Container>
  )
}

export default ImageFan
